/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {useThemeMode} from '../../../partials/layout/theme-mode/ThemeModeProvider'
import {Header} from './Header'
import {Navbar} from './Navbar'
import {ETLWidget} from './ETLWidget'
import {useAuth} from '../../../../app/modules/auth'

export function HeaderWrapper() {
  const {currentUser} = useAuth()
  const {config, classes} = useLayout()
  const {mode} = useThemeMode()

  if (!config.app?.header?.display) {
    return null
  }

  // Theme-aware styles
  const buttonContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    width: '60px',
    height: '50px',
    textAlign: 'center',
    position: 'relative',
    marginTop: '15px'
  }

  const dashboardBtnStyle: React.CSSProperties = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '14px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.2s',
    position: 'relative'
  }

  // Determine current theme
  const systemMode = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  const currentTheme = mode === 'system' ? systemMode : mode

  const tooltipStyle: React.CSSProperties = {
    position: 'absolute',
    bottom: '-35px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: currentTheme === 'dark' ? '#374151' : '#1f2937',
    color: '#ffffff',
    padding: '6px 12px',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity 0.2s, visibility 0.2s, transform 0.2s',
    zIndex: 1000,
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    pointerEvents: 'none'
  }

  const tooltipArrowStyle: React.CSSProperties = {
    position: 'absolute',
    top: '-4px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderLeft: '4px solid transparent',
    borderRight: '4px solid transparent',
    borderBottom: `4px solid ${currentTheme === 'dark' ? '#374151' : '#1f2937'}`
  }

  const svgFillColor = currentTheme === 'dark' ? '#d1d5db' : '#6b7280'

  return (
    <div id='kt_app_header' className='app-header'>

      <div
        id='kt_app_header_container'
        className={clsx(
          'app-container flex-lg-grow-1',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        {/* Apps Dashboard Button - Only for Designer Eyes */}
        {currentUser?.decoded?.vendorName === 'Designer Eyes' && (
          <div style={buttonContainerStyle}>
            <Link to='/apps-dashboard' style={{ textDecoration: 'none' }}>
              <button 
                style={dashboardBtnStyle}
                title="Apps Dashboard"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.1)'
                  const tooltip = e.currentTarget.querySelector('.tooltip') as HTMLElement
                  if (tooltip) {
                    tooltip.style.opacity = '1'
                    tooltip.style.visibility = 'visible'
                    tooltip.style.transform = 'translateX(-50%) translateY(-2px)'
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)'
                  const tooltip = e.currentTarget.querySelector('.tooltip') as HTMLElement
                  if (tooltip) {
                    tooltip.style.opacity = '0'
                    tooltip.style.visibility = 'hidden'
                    tooltip.style.transform = 'translateX(-50%) translateY(0px)'
                  }
                }}
              >
                <svg width="32" height="32" fill={svgFillColor} viewBox="0 0 24 24">
                  <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8v-10h-8v10zm0-18v6h8V3h-8z"/>
                </svg>
                <div className="tooltip" style={tooltipStyle}>
                  <div style={tooltipArrowStyle}></div>
                  Apps
                </div>
              </button>
            </Link>
          </div>
        )}

        {/* ETL Dashboard Widget - Only for Designer Eyes */}
        {currentUser?.decoded?.vendorName === 'Designer Eyes' && <ETLWidget />}

        {config.app.sidebar?.display && (
          <>
            <div
              className='d-flex align-items-center d-lg-none ms-n2 me-2'
              title='Show sidebar menu'
            >
              <div
                className='btn btn-icon btn-active-color-primary w-35px h-35px'
                id='kt_app_sidebar_mobile_toggle'
              >
                <KTIcon iconName='abstract-14' className=' fs-1' />
              </div>
              <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                <Link to='/dashboard' className='d-lg-none'>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default-small.svg')}
                    className='h-30px'
                  />
                </Link>
              </div>
            </div>
          </>
        )}

        {!(config.layoutType === 'dark-sidebar' || config.layoutType === 'light-sidebar') && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
            <Link to='/dashboard'>
              {config.layoutType !== 'dark-header' ? (
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('/media/logos/default.svg')}
                  className='h-20px h-lg-30px app-sidebar-logo-default'
                />
              ) : (
                <>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default-dark.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-light-show'
                  />
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default-small-dark.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-dark-show'
                  />
                </>
              )}
            </Link>
          </div>
        )}

        <div
          id='kt_app_header_wrapper'
          className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'
        >
          {config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                className='app-header-menu app-header-mobile-drawer align-items-stretch'
                data-kt-drawer='true'
                data-kt-drawer-name='app-header-menu'
                data-kt-drawer-activate='{default: true, lg: false}'
                data-kt-drawer-overlay='true'
                data-kt-drawer-width='225px'
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle='#kt_app_header_menu_toggle'
                data-kt-swapper='true'
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
              >
                <Header />
              </div>
            )}
          <Navbar />
        </div>
      </div>
    </div>
  )
}
